import React from "react"
import EventsRadioGroup from "../../Radiobutton/EventsRadioGroup"
import Search from "../../actions/Search"
import {Grid} from "@mui/material"

interface EventsToolbarProps {
	eventType: string
	searchText: string
	updateSearchText: (searchText: string) => void
	updateEventsType: (eventsType: string) => void
}
export default function EventsToolbar(props: EventsToolbarProps) {
	return (
		<Grid
			container
			spacing={2}
			justifyContent="flex-end"
			direction="row"
			alignItems="center"
			style={{marginRight: "16px"}}
		>
			<Grid item xs={3} />
			<Grid item>
				<EventsRadioGroup value={props.eventType} onChange={props.updateEventsType} />
			</Grid>
			<Grid item>
				<Search
					searchTerm={props.searchText}
					label="Search"
					onSearch={props.updateSearchText}
					width="324px"
				/>
			</Grid>
		</Grid>
	)
}
